import PlayClient from '@empathybroker/tsclient-play';
import { Auth } from '@empathybroker/tsclient-play/dist/models/auth';
import { LoginCredentials } from '@empathybroker/tsclient-play/dist/models/login-credentials';
import { PlayResponse } from '@empathybroker/tsclient-play/dist/models/play-response';

import { ActionContext } from 'vuex';

import { CONTAINER, TYPES } from '../../../config';

import { ActionClass, AuthState, ContextState } from '../../../models';

import { StorageService } from '../../../services';

import { AUTH_CONSTS } from '../../auth/auth.consts';
import { CONTEXT_CONSTS } from '../../context/context.consts';

export class LoginAction implements ActionClass {

  public static async execute({ commit, rootGetters }: ActionContext<AuthState, any>,
    payload: { credentials: LoginCredentials; keepLoggedIn: boolean }): Promise<PlayResponse> {
    const context: ContextState = rootGetters[`${ CONTEXT_CONSTS.moduleName }/${ CONTEXT_CONSTS.getters.context }`];
    const playClient: PlayClient = CONTAINER.get<(context: ContextState) => PlayClient>(TYPES.PlayClient)(context);
    try {
      const playResponse: PlayResponse = await playClient.login(payload.credentials);
      const playResponseData = (playResponse.data as Auth);
      const token = playResponseData.accessToken;
      const refreshToken = playResponseData.refreshToken;
      const keepLoggedIn = (payload.keepLoggedIn || false);
      commit(AUTH_CONSTS.mutations.setState, {
        token,
        refreshToken,
        keepLoggedIn
      });
      const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService);
      storageService.setItem(AUTH_CONSTS.storage.token, token);
      storageService.setItem(AUTH_CONSTS.storage.refreshToken, refreshToken);
      storageService.setItem(AUTH_CONSTS.storage.keepLoggedIn, keepLoggedIn.toString());
      return playResponse;
    } catch (error) {
      throw error;
    }
  }

}
